// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"9cd2abfb","787":"272af0be","967":"5eded3c3"}[chunkId] + ".chunk.js";
};